
export default class Qeustao {

    constructor(){
        this.codigo = ''
        this.comentario = ''
        this.dtCadastro = ''
        this.tema = ''
        this.pergunta = ''
        this.linkVideo = ''
        this.respostas = []
    }
  }


